import { useLang } from "@/i18n";

const Marquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div className="ticker" aria-label={t.marquee.join(", ")} data-testid="marquee">
      <div className="ticker-track">
        {items.map((item, i) => (
          <span key={i} style={{ display: "contents" }}>
            <span>{item}</span>
            <i>✦</i>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
